/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Component} from '@angular/core';

import {ProfileMode} from '../../app.constants';
import {Destroyable} from '../../destroyable.component';

@Component({
  selector: 'gp-hire',
  templateUrl: 'hire.component.html'
})
export class HireComponent extends Destroyable {

  public static ACCESS_NAME: string = 'MSSHire';
  public profileMode = ProfileMode.MSS;
}
